import { BASE_PATHS } from '@oneclick/constants/navigation';
import { ACCESS_CONTROL_ROUTE_CONFIG } from '@oneclick/pages/access-control/accessControlRouteConfig';
import {
  CLUSTER_BREADCRUMB_ONLY,
  CLUSTER_ROUTE_CONFIG,
  flattenClusterNavItems,
} from '@oneclick/pages/cluster/clusterRouteConfig';
import {
  CLUSTERS_HOME_ROUTE_CONFIG,
  ORG_BREADCRUMB_ONLY,
} from '@oneclick/pages/orgRouteConfig';
import { OVERVIEW_ROUTE_CONFIG } from '@oneclick/pages/overview/overviewRouteConfig';
import { SETTINGS_ROUTE_CONFIG } from '@oneclick/pages/settings/settingsRouteConfig';
import { SSO_ROUTE_CONFIG } from '@oneclick/pages/settings/ssoRouteConfig';
import { flattenNavItems, matchBreadcrumbs, toPageLabel } from './utils';
import type {
  NormalizedBreadcrumbItem,
  OneClickBreadcrumbOnlyItem,
  OneClickLinkItem,
} from './types';

const withBasePath = (
  basePath: string,
  items: OneClickLinkItem[]
): OneClickLinkItem[] =>
  items.map((item) => ({
    ...item,
    matchRoute:
      item.matchRoute ??
      `${basePath}/${item.route}`.replace(/\/\*$/, '').replace(/\/+/g, '/'),
  }));

const ONECLICK_BREADCRUMB_LEAVES: Array<
  OneClickLinkItem | OneClickBreadcrumbOnlyItem
> = [
  ...flattenNavItems(CLUSTERS_HOME_ROUTE_CONFIG),
  ...withBasePath(
    BASE_PATHS.accessControl,
    flattenNavItems(ACCESS_CONTROL_ROUTE_CONFIG)
  ),
  ...withBasePath(BASE_PATHS.ssoConnections, flattenNavItems(SSO_ROUTE_CONFIG)),
  ...withBasePath(BASE_PATHS.overview, flattenNavItems(OVERVIEW_ROUTE_CONFIG)),
  ...withBasePath(
    BASE_PATHS.settings,
    flattenNavItems(SETTINGS_ROUTE_CONFIG).filter((item) => item.route !== '*')
  ),
  ...ORG_BREADCRUMB_ONLY,
  ...CLUSTER_BREADCRUMB_ONLY,
  ...flattenClusterNavItems(CLUSTER_ROUTE_CONFIG),
];

const matchOneClickBreadcrumbs = (pathname: string, search = '') =>
  matchBreadcrumbs({
    pathname,
    search,
    items: ONECLICK_BREADCRUMB_LEAVES,
  });

export const resolveOneClickPageLabel = (
  pathname: string,
  search = ''
): NormalizedBreadcrumbItem[] | undefined =>
  toPageLabel(matchOneClickBreadcrumbs(pathname, search));
